import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ibm-aiops-training/ibm-aiops-training/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`🚀 TASK: Get the configuration Information`}</h2>
    <p>{`This will provide you with all the information and details that you need to configure CP4AIOPS in this chapter.`}</p>
    <img {...{
      "src": "./../images/57_my_info.png",
      "alt": "image"
    }}></img>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Run the following command to save a list of all the information to the `}<inlineCode parentName="p">{`MY_CONFIGURATION.txt`}</inlineCode>{` file.`}</p>
        <p parentName="li">{`You will need this information for the configuration of CP4AIOPS in this chapter.`}</p>
      </li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`./tools/11_practicum/get_configuration_info.sh > MY_CONFIGURATION.txt
`}</code></pre>
    <InlineNotification kind="info" mdxType="InlineNotification">
You can ignore the following message:
Command "get-token" is deprecated, and will be removed in the future version. Use oc create token instead.
    </InlineNotification>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      